import React from 'react';
import { formatDate } from '../../lib/dateUtils';

interface DayBookPrintProps {
  data: {
    company: {
      name: string;
      address: string;
    };
    reportMeta: {
      fromDate: string;
      toDate: string;
    };
    vouchers: {
      date: string;
      particulars: string;
      vchType: string;
      vchNo: string;
      debit: string;
      credit: string;
    }[];
    totals: {
      debit: string;
      credit: string;
    };
  };
}

const DayBookPrint: React.FC<DayBookPrintProps> = ({ data }) => {
  return (
    <div className="print-report p-6 text-black font-sans text-[12px] bg-white"
      style={{ width: '210mm', boxSizing: 'border-box' }}
    >
      {/* Header */}
      <div className="text-center border-b-2 border-black pb-4 mb-4">
        <h1 className="text-2xl font-bold uppercase">{data.company.name}</h1>
        <p className="text-[14px]">{data.company.address}</p>
        <h2 className="text-lg font-bold mt-2 underline">DAY BOOK</h2>
        <p className="text-[12px] font-semibold text-gray-700">Period: {formatDate(data.reportMeta.fromDate)} to {formatDate(data.reportMeta.toDate)}</p>
      </div>

      {/* Table */}
      <table className="w-full border-collapse border border-black">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-black px-2 py-1 text-left w-[80px]">Date</th>
            <th className="border border-black px-2 py-1 text-left">Particulars</th>
            <th className="border border-black px-2 py-1 text-left w-[100px]">Vch Type</th>
            <th className="border border-black px-2 py-1 text-right w-[80px]">Vch No.</th>
            <th className="border border-black px-2 py-1 text-right w-[100px]">Debit</th>
            <th className="border border-black px-2 py-1 text-right w-[100px]">Credit</th>
          </tr>
        </thead>
        <tbody>
          {data.vouchers.map((v, idx) => (
            <tr key={idx}>
              <td className="border border-black px-2 py-1">{formatDate(v.date)}</td>
              <td className="border border-black px-2 py-1 italic font-semibold">{v.particulars}</td>
              <td className="border border-black px-2 py-1">{v.vchType}</td>
              <td className="border border-black px-2 py-1 text-right">{v.vchNo}</td>
              <td className="border border-black px-2 py-1 text-right font-bold">{v.debit}</td>
              <td className="border border-black px-2 py-1 text-right font-bold">{v.credit}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-100 font-bold">
            <td colSpan={4} className="border border-black px-2 py-1 text-right uppercase tracking-wide">Grand Total</td>
            <td className="border border-black px-2 py-2 text-right text-[13px]">{data.totals.debit}</td>
            <td className="border border-black px-2 py-2 text-right text-[13px]">{data.totals.credit}</td>
          </tr>
        </tfoot>
      </table>

      {/* Footer */}
      <div className="mt-12 flex justify-between">
        <div className="text-center">
          <div className="border-t border-black w-32 mt-8 pt-1">Prepared By</div>
        </div>
        <div className="text-center">
          <div className="border-t border-black w-32 mt-8 pt-1">Verified By</div>
        </div>
        <div className="text-center">
          <div className="border-t border-black w-32 mt-8 pt-1">Authorised Signatory</div>
        </div>
      </div>
      
      <div className="mt-8 text-[10px] text-gray-500 text-center">
        This is a computer generated document.
      </div>
    </div>
  );
};

export default DayBookPrint;
